import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { useT } from "@/i18n/useT";

export default function ContactPage() {
  const t = useT();
  const c = t.contact;
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);
  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await api.post("/contact", form); toast(c.success); setForm({ name: "", email: "", message: "" }); }
    catch { toast(c.error); }
    finally { setLoading(false); }
  };
  return (
    <div data-testid="contact-page" className="br-container py-20 md:py-28">
      <div className="grid md:grid-cols-12 gap-16">
        <div className="md:col-span-5 br-fade-in">
          <div className="br-eyebrow mb-4">{c.eyebrow}</div>
          <h1 className="font-serif text-4xl md:text-5xl text-espresso leading-tight whitespace-pre-line">{c.title}</h1>
          <p className="mt-8 text-base font-light text-dark-walnut leading-relaxed">{c.body}</p>
          <div className="mt-12 space-y-5 text-sm font-light text-dark-walnut">
            <div><div className="br-eyebrow mb-1">{c.emailLabel}</div><a href="mailto:hello@balticroots.store" className="br-link-underline">hello@balticroots.store</a></div>
            <div><div className="br-eyebrow mb-1">{c.studioLabel}</div><div>{c.studioValue}</div></div>
          </div>
        </div>
        <form onSubmit={submit} data-testid="contact-form" className="md:col-span-6 md:col-start-7 space-y-8 br-fade-in">
          <div><label className="br-eyebrow block mb-2">{c.nameLabel}</label><input data-testid="contact-name" required value={form.name} onChange={update("name")} className="br-input" /></div>
          <div><label className="br-eyebrow block mb-2">{c.emailFieldLabel}</label><input data-testid="contact-email" required type="email" value={form.email} onChange={update("email")} className="br-input" /></div>
          <div><label className="br-eyebrow block mb-2">{c.messageLabel}</label><textarea data-testid="contact-message" required rows={6} value={form.message} onChange={update("message")} className="br-input resize-none" /></div>
          <button data-testid="contact-submit" disabled={loading} type="submit" className="br-btn-solid disabled:opacity-50">{loading ? c.sending : c.submit}</button>
        </form>
      </div>
    </div>
  );
}